import { render, staticRenderFns } from "./ActionSubForm.vue?vue&type=template&id=37e463a2&scoped=true"
import script from "./ActionSubForm.vue?vue&type=script&lang=js"
export * from "./ActionSubForm.vue?vue&type=script&lang=js"
import style0 from "./ActionSubForm.vue?vue&type=style&index=0&id=37e463a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37e463a2",
  null
  
)

export default component.exports